import React from 'react';

import { Container } from '../Container/Container';
import { Heading } from '../Heading/Heading';
import NextImage, { ImageLoaderProps } from 'next/image';
import { Text } from '../Text/Text';

import quoteMarksEnd from './assets/quoteMarksEnd.png';
import quoteMarksStart from './assets/quoteMarksStart.png';
import { ContentfulResizeTypes, getContentfulLoader } from '../../helpers/imageLoaders/contentful';
import { AssetFile } from 'contentful';

interface IProps {
  quote: string;
  author: string;
  aboutAuthor: string;
  authorImage?: AssetFile | undefined;
}

export const QuoteSection = ({ quote, author, aboutAuthor, authorImage }: IProps) => {
  const ASPECTWIDTH = 4;
  const ASPECTHEIGTH = 3;

  const contentfulLoader = ({ src, width, quality }: ImageLoaderProps): string =>
    getContentfulLoader(src, width, ASPECTWIDTH, ASPECTHEIGTH, {
      quality,
      resize: ContentfulResizeTypes.PAD,
    });

  return (
    <Container
      className={`py-sm mx-auto flex flex-col items-center justify-center sm:px-36 ${
        authorImage ? 'md:flex-row-reverse md:gap-12' : ''
      }`}
      data-testid="QuoteSection"
    >
      <div className="grid max-w-[650px] grid-cols-1 grid-rows-1">
        <Heading variant="md" className="order-1 col-start-1 row-start-1 my-7 text-center">
          {quote}
        </Heading>
        <div className="col-start-1 row-start-1">
          <NextImage unoptimized src={quoteMarksStart} alt="quotation marks start" />
        </div>

        <div className="col-start-1 row-start-1 flex size-full items-end justify-end sm:hidden md:flex">
          <NextImage unoptimized src={quoteMarksEnd} alt="quotation marks end" />
        </div>
      </div>

      <div className="mt-4 flex items-center justify-center md:order-1 md:flex-col">
        {authorImage && (
          <NextImage
            src={authorImage.url}
            loader={contentfulLoader}
            width={authorImage.details.image?.width ?? 0}
            height={authorImage.details.image?.height ?? 0}
            alt={author}
          />
        )}

        <div className="md:flex md:flex-col md:items-center">
          <Text className={`mb-0 font-semibold md:mt-2 ${authorImage ? '' : 'text-center'}`}>
            {author}
          </Text>
          <Text className={`mb-0 ${authorImage ? '' : 'text-center'}`}>{aboutAuthor}</Text>
        </div>
      </div>
    </Container>
  );
};
